import TextTitle from 'components/TextTitle'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'

const TITLE = 'Gymaholic'

export default function PageTitle ({ children }) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  return (
    <h1>
      {
        children && typeof children !== 'string'
          ? children
          : (
            <TextTitle
              fs={isSmallScreen ? 'small' : 'title'}
            >
              {children || TITLE}
            </TextTitle>
            )
      }
    </h1>
  )
}
